import axios from "axios";
import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import "./app.scss";
import PortalLayout from "./app/pages/portal/components/layout/portal-layout";
import PortalRoutes from "./app/pages/portal/portal-routes";

export default function PortalApp() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    fetch("/assets/config/appSettings.json")
      .then((res) => res.json())
      .then((data) => {
        axios.defaults.baseURL = data.portalAdmin.apiUrl;
      })
      .catch(() => {
        console.warn("[PortalApp] No se pudo cargar appSettings.json");
      })
      .finally(() => setReady(true));
  }, []);

  if (!ready) return null;

  return (
    <div className="portal-app">
      <main>
        <Routes>
          <Route path="/" element={<PortalLayout />}>
            {PortalRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            ))}
          </Route>
        </Routes>
        {/* <Outlet /> */}
      </main>
    </div>
  );
}
